import {
  AutoComplete,
  Badge,
  Button,
  Checkbox,
  DatePicker,
  Dropdown,
  Form,
  message,
  Modal,
  Radio,
  Select,
  Space,
  Switch,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import Table, { ColumnsType, TableProps } from "antd/es/table";
import { ApiService } from "api/api.service";
import ErrorComponent from "components/ErrorComponent";
import PageTitle from "components/PageTitle";
import dayjs from "dayjs";
import { BankDto } from "dtos/bank.dto";
import { Transaction } from "dtos/transaction.dto";
import { RoleTypes } from "dtos/user.dto";
import DashboardLayout from "layout/DashboardLayout";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  TbArrowsUpDown,
  TbChevronLeft,
  TbChevronRight,
  TbCircleCheck,
  TbEdit,
  TbLoader,
  TbRobotFace,
  TbSortAscendingNumbers,
  TbSortDescendingNumbers,
  TbSwitch,
  TbToggleRight,
  TbWriting,
  TbX,
} from "react-icons/tb";
import { useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { RootState } from "store";
import { userSlice } from "store/userSlice";
import { formatDate, formatDateTime, formatMoney, getErrorMessage } from "utils/functions";
import { set } from "zod";

// const bankOptions = [
//   { value: "bankA", label: "Bank A" },
//   { value: "bankB", label: "Bank B" },
//   { value: "bankC", label: "Bank C" },
// ];
// const allCreditTransactions = [
//   // TRANSFER
//   "From Own Account",
//   "Customer Transfer",
//   "Wallet Load",

//   // PROCESSOR PAYMENT
//   "Settlement from Razorpay",
//   "Settlement from Cashfree",
//   "Payment Gateway Inflow",

//   // MCA / LOAN
//   "Loan Disbursement",
//   "MCA Funding",
//   "Line of Credit Draw",

//   // NSF TRANSACTION
//   "Reversal of Returned Transaction",
//   "Refund of NSF Fee",

//   // OVERTRAN TRANSACTION
//   "Overdraft Utilization",
//   "OD Adjustment",

//   // MOBILE PAYMENT
//   "UPI Received",
//   "GPay Received",
//   "PhonePe Received",
//   "Paytm UPI Inflow",

//   // BILL PAYMENT
//   "Bill Refund",
//   "Auto Reversal of Bill",

//   // VENDOR PAYMENT
//   "Vendor Refund",
//   "Reimbursement from Vendor",

//   // STAFF PAYMENT
//   "Salary Refund",
//   "Expense Reimbursement",

//   // INVESTMENT
//   "Dividend Credit",
//   "Investment Redemption",

//   // BANK CHARGES
//   "Charge Reversal",

//   // CASH TRANSACTION
//   "Cash Deposit",
//   "ATM Deposit",

//   // TAX / STATUTORY
//   "Tax Refund",
//   "TDS Refund",

//   // OTHER / MISC
//   "Refund Adjustment",
//   "Miscellaneous Credit",
// ];
// const allDebitTransactions = [
//   // TRANSFER
//   "To Own Account",
//   "To Wallet",
//   "Vendor Transfer",

//   // PROCESSOR PAYMENT
//   // "Payout to Razorpay",
//   "Payment Gateway Fee",
//   "Processor Deduction",

//   // MCA / LOAN
//   "EMI Payment",
//   "MCA Repayment",
//   "Auto Debit from Account",

//   // NSF TRANSACTION
//   "Cheque Bounce",
//   "NSF Fee Deducted",

//   // OVERTRAN TRANSACTION
//   "Overdraft Interest",
//   "Overtran Fee",

//   // MOBILE PAYMENT
//   // "UPI Sent",
//   // "GPay Payment",
//   // "PhonePe Payment",
//   // "Paytm UPI Outflow",
//   "Wire Transfer",

//   // BILL PAYMENT
//   "Electricity Bill",
//   "Credit Card Bill",
//   "Insurance Premium",
//   "Subscription AutoPay",

//   // VENDOR PAYMENT
//   "Vendor Payment",
//   "Supplier Transfer",
//   "Invoice Payment",

//   // STAFF PAYMENT
//   "Payroll",
//   "Staff Advance",
//   "Employee Expense",

//   // INVESTMENT
//   "Mutual Fund Purchase",
//   "Stock Purchase",
//   "Deposit to Trading Account",

//   // BANK CHARGES
//   "Service Charge",
//   "SMS Charge",
//   "Penalty",
//   "Interest Debit",

//   // CASH TRANSACTION
//   "Cash Withdrawal",
//   "ATM Withdrawal",

//   // TAX / STATUTORY
//   "GST Payment",
//   "TDS Payment",
//   "Income Tax",
//   "PF / ESIC",

//   // OTHER / MISC
//   "Miscellaneous Debit",
//   "Adjustment",
//   "Unknown Debit",
// ];

const availableCategories = [
  "BANK_FEE",
  "CARD_PAYMENT",
  "CONSTRUCTION",
  "FACTORING",
  "FUEL",
  "HEALTHCARE",
  "INSURANCE",
  "INTERBANK",
  "INVESTMENT",
  "MCA",
  "MOBILE_PAYMENT",
  "NEFARIOUS",
  "NONDESCRIPT",
  "NSF",
  "OTHER_FINANCING",
  "OVERDRAFT",
  "PAYROLL",
  "PROCESSOR_PAYMENT",
  "PROFESSIONAL_SERVICES",
  "RENT",
  "RETURNS",
  "SETTLEMENT_PAYMENT",
  "SOFTWARE",
  "TAX_PAYMENT",
  "TOLLS",
  "TRANSFER",
  "UTILITIES",
];
const availableSubCategories = [
  "truecredit",
  "nontruecredit",
  "reversal",
  "charge",
  "settlement",
  "loan",
  "tax",
  "investment",
  "salary",
  "vendor",
  "wallet",
  "cash",
  "processor",
  "miscellaneous",
];

// type CategoryToggleState = Record<string, boolean>;

const BankAccount = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const appKey = useParams().appkey;
  const start_date = searchParams.get("start_date") || undefined;
  const end_date = searchParams.get("end_date") || undefined;
  const page = Number(searchParams.get("page")) || 1;
  const limit = Number(searchParams.get("limit")) || 20;
  const sortBy = searchParams.get("sortBy") || undefined;
  const sortOrder = Number(searchParams.get("sortOrder")) || 1;

  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkUpdate, setIsBulkUpdate] = useState(false);
  const [indivudaulUpdate, setIsIndividaulUpdate] = useState(true);
  const [iframeUrl, setIframeUrl] = useState<string | undefined>(undefined);
  const [showOldView, setShowOldView] = useState(true);

  // console.log(indivudaulUpdate, "this is indivudaulUpdate");
  const [transactionType, setTransactionType] = useState<"debit" | "credit">("credit");
  const [transactionDescription, setTransactionDescription] = useState<string | undefined>(undefined);
  const [transactionId, setTransactionId] = useState<number | undefined>(undefined);
  const [editScopeAll, setEditScopeAll] = useState(false);

  const [form] = Form.useForm();

  const [startDate, setStartDate] = useState<string | undefined>(start_date);
  const [endDate, setEndDate] = useState<string | undefined>(end_date);
  const [selectedMonth, setSelectedMonth] = useState<string>();
  const [selectedRow, setSelectedRow] = useState<number[]>([]);
  const [allCategories, setAllCategories] = useState<string[]>([]);

  const user = useSelector((state: RootState) => state.user);

  const updateCategoryMutation = ApiService.application.useUpdateBankCacheCategory();

  const updateSingleCategoryMutation = ApiService.application.useUpdateSingleBankCacheCategory();
  const markRecievable = ApiService.application.useMarkReceivable();
  const markedReceivables = ApiService.application.useGetMarkedReceivables(appKey) || [];
  const transactionMonths = ApiService.application.useGetTransactionMonths(appKey) || [];
  const bulkCategoryUpdateMutation = ApiService.application.useBulkUpdateBankCacheCategory();

  const [categoryFilter, setCategoryFilter] = useState<string[]>([]);
  useEffect(() => {
    if (markRecievable.data) {
      setAllCategories(markedReceivables.data?.upstream ?? []);
    }
  }, [markRecievable.data]);
  // console.log({ mark: markedReceivables.data });

  useEffect(() => {
    if (transactionMonths?.data && transactionMonths?.data?.months?.length > 0) {
      const firstMonth = transactionMonths?.data?.months?.[0];
      setSelectedMonth(firstMonth);
      if (!startDate && !endDate) {
        const startDate = dayjs(firstMonth, "YYYY/MM").startOf("month").format("YYYY-MM-DD");
        const endDate = dayjs(firstMonth, "YYYY/MM").endOf("month").format("YYYY-MM-DD");

        setSearchParams((prev) => {
          const newSP = new URLSearchParams(prev);
          newSP.set("start_date", startDate);
          newSP.set("end_date", endDate);
          return newSP;
        });
        setStartDate(startDate);
        setEndDate(endDate);
      }
    }
  }, [transactionMonths.data]);
  const hasFired = useRef(false);
  const fullApplication = ApiService.application.useGetByAppKey(appKey);

  const bank = ApiService.application.useGetBankDataML({
    appkey: appKey,
    start_date: startDate,
    end_date: endDate,
    page,
    limit,
    sortBy,
    sortOrder,
    category: categoryFilter,
  });
  const optionsQuery = ApiService.application.useGetDSRiskReportOptions(appKey);
  const runReport = ApiService.application.useGetDSRiskRunReport();
  const columns: ColumnsType<Transaction> = [
    {
      title: "Account Number",
      dataIndex: "account_number",
      key: "account_number",
      width: 140,
    },
    {
      title: "Transaction Date",
      dataIndex: "transaction_date",
      key: "transaction_date",
      width: 140,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Balance",
      dataIndex: "balance",
      key: "balance",
      width: 120,
      render: (val) => formatMoney(val),
    },
    {
      title: "Credit/Debit",
      dataIndex: "creditordebit",
      key: "creditordebit",
      width: 100,
      render: (val: string) => {
        return <Tag color={val === "Credit" ? "green" : "red"}>{val?.toUpperCase()}</Tag>;
      },
    },

    {
      title: "Credit Amount",
      dataIndex: "credit_amount",
      key: "credit_amount",
      width: 120,
      render: (val) => formatMoney(val),
      align: "right",
    },
    {
      title: "Debit Amount",
      dataIndex: "debit_amount",
      key: "debit_amount",
      width: 120,
      render: (val) => formatMoney(val),
      align: "right",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      width: 160,
    },

    {
      title: "Subcategory",
      dataIndex: "subcategory",
      key: "subcategory",
      width: 160,
    },
    {
      title: "Updated",
      dataIndex: "updated",
      key: "updated",
      render: (val: string) => {
        return (
          <Tag
            color={
              val === "AI Auto Update"
                ? "green"
                : val === "Manual AI Update"
                  ? "red"
                  : val === "Manual Update"
                    ? "cyan"
                    : ""
            }
            icon={
              val === "AI Auto Update" ? (
                <TbRobotFace />
              ) : val === "Manual AI Update" ? (
                <TbLoader />
              ) : val === "Manual Update" ? (
                <TbWriting />
              ) : (
                ""
              )
            }
          >
            {val?.toUpperCase()}
          </Tag>
        );
      },
    },
    ...(selectedRow.length < 1
      ? [
          {
            title: "Action",
            width: 80,
            render: (_: any, record: Transaction) => {
              return (
                <Button
                  icon={<TbEdit />}
                  type="text"
                  onClick={() => {
                    if (record.credit_amount && record.credit_amount > 0) {
                      setTransactionType("credit");
                    } else {
                      setTransactionType("debit");
                    }

                    setTransactionDescription(record.description);
                    setTransactionId(record.id);

                    form.setFieldsValue({
                      category: record.category || "",
                      sub_cat: record.subcategory || "",
                      description: record.description || "",
                    });

                    setSelectedCategory(record.category || "");
                    setIsBulkUpdate(false);
                    setIsModalOpen(true);
                    // console.log(record.updated);
                    setEditScopeAll(record.updated === "AI Auto Update" || record.updated === null);
                  }}
                />
              );
            },
          },
        ]
      : []),
  ];

  const [recievablesModal, setRecievablesModal] = useState(false);
  const [categories, setCategories] = useState<Record<string, boolean>>({});
  const [upstream, setUpstream] = useState<string[]>([]);

  type ScopeOption = "single" | "category" | "application";

  useEffect(() => {
    if (!optionsQuery.isSuccess || !fullApplication.isSuccess) return;
    if (!optionsQuery.data || !fullApplication.data) return;
    if (hasFired.current) return;

    hasFired.current = true;

    const body = {
      name: fullApplication.data?.application.meta.client_name || "User",
      email: `auto-${fullApplication.data?.application.app_key}@datasense.mindwebs.co`,
      appkey: fullApplication.data?.application.app_key || "",
      ruleSetIds: optionsQuery.data.result.ruleSetIds,
      aiAuditReportKeys: [],
      loans: (fullApplication.data?.data.application.loans ?? []).map(({ attachments, ...loan }) => loan),
    };

    runReport.mutate(
      {
        ...body,
      },
      {
        onSuccess: (res) => {
          console.log({ res });
          console.log({ iframeInMutation: res.result.bankStatementRedirectUrl });
          setIframeUrl(res.result.bankStatementRedirectUrl);
        },
      },
    );
    // consumeCredits.mutate({
    //   appkey: fullApplication.data?.application.app_key,
    //   amount: 1,
    //   credit_type: CreditTypes.AI_AUDIT,
    //   description: "1 credit consumed for generating Auto Insight (APR) Report.",
    //   extra: {
    //     isDSRisk: true,
    //   },
    // });
  }, [optionsQuery.isSuccess, optionsQuery.data, fullApplication.isSuccess, fullApplication.data]);
  console.log({ iframeUrl });

  useEffect(() => {
    if (markedReceivables.data) {
      setCategories(markedReceivables.data.saved || {});
      setUpstream(markedReceivables.data.upstream || []);
    }
  }, [markedReceivables.data]);

  const toggle = (key: string) => {
    const newValue = !categories[key];

    setCategories((prev) => ({
      ...prev,
      [key]: newValue,
    }));

    markRecievable.mutate(
      { appkey: appKey ?? "", category: key, value: newValue },
      {
        onSuccess: () => markedReceivables.refetch(),
        onError: () => {
          setCategories((prev) => ({
            ...prev,
            [key]: !newValue,
          }));
        },
      },
    );
  };
  const rowSelection: TableProps<Transaction>["rowSelection"] = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: Transaction[]) => {
      setSelectedRow(selectedRowKeys as number[]);
    },
    selectedRowKeys: selectedRow,
  };
  if (bank.isError) {
    return <ErrorComponent error={bank.error} />;
  }

  return (
    <DashboardLayout
      headerRight={
        <div className="flex items-center gap-3">
          <Button onClick={() => setRecievablesModal(true)} type="primary" icon={<TbToggleRight />}>
            Mark Recievable Categories
          </Button>
          {iframeUrl && (
            <Button
              icon={<TbSwitch />}
              onClick={() => setShowOldView((prev) => !prev)}
              type="primary"
              variant="solid"
              color="magenta"
            >
              {showOldView ? `Use New View` : `Use Old View`}
            </Button>
          )}
        </div>
      }
    >
      <PageTitle
        pageTitle={[
          { title: "Applications", link: `/dashboard/applications` },
          {
            title:
              fullApplication.data?.data?.application?.client_details?.name ??
              fullApplication.data?.application?.meta?.client_name ??
              "Application Item",
            link: `/dashboard/application/${appKey}`,
          },
          { title: "Bank Statements" },
        ]}
        title="Bank Statements"
      />
      {showOldView ? (
        <>
          <div className="flex justify-between items-center gap-4 my-4 px-4">
            <>
              <div>
                {bank.data?.result?.timestamps ? (
                  <div className="flex items-center gap-2 text-xs bg-green-50 px-2 py-1 rounded-md w-fit">
                    <Badge status="success" />
                    <Typography.Text className="text-gray-500">Last updated</Typography.Text>
                    <span className="text-gray-700 font-medium">
                      {bank.data?.result?.timestamps && formatDateTime(bank.data.result.timestamps)}
                    </span>
                  </div>
                ) : (
                  <div className="flex items-center gap-2 text-xs bg-red-50 px-2 py-1 rounded-md w-fit">
                    <Badge status="error" />
                    <Typography.Text className="text-red-600">Not updated</Typography.Text>
                  </div>
                )}
              </div>

              <div className="space-x-2">
                {selectedRow.length > 0 && (
                  <Button
                    onClick={() => {
                      setIsModalOpen(true);
                      setIsBulkUpdate(true);
                      setIsIndividaulUpdate(false);
                      form.resetFields();
                    }}
                  >
                    Update Category ({selectedRow.length})
                  </Button>
                )}
                <Dropdown
                  menu={{
                    items: upstream.map((val, i) => ({
                      key: val,
                      label: (
                        <div className="flex gap-2" key={i}>
                          <Checkbox
                            checked={categoryFilter?.includes(val)}
                            onChange={() => {
                              if (categoryFilter?.includes(val)) {
                                setCategoryFilter(categoryFilter.filter((pval) => pval !== val));
                              } else {
                                setCategoryFilter([...(categoryFilter || []), val]);
                              }
                            }}
                          />
                          <Tag>{val}</Tag>
                        </div>
                      ),
                    })),
                  }}
                  trigger={["click"]}
                >
                  <Button>Select Category</Button>
                </Dropdown>
                <Space.Compact>
                  <Dropdown
                    trigger={["click"]}
                    menu={{
                      selectable: true,
                      selectedKeys: sortBy ? [sortBy] : [],
                      onSelect: ({ key }) => {
                        setSearchParams((prev) => {
                          const newParams = new URLSearchParams(prev);
                          newParams.set("sortBy", key);
                          newParams.set("sortOrder", sortOrder.toString());
                          return newParams;
                        });
                      },
                      items: [
                        {
                          key: "credit_amount",
                          label: "Credit Amount",
                        },
                        {
                          key: "debit_amount",
                          label: "Debit Amount",
                        },
                        {
                          key: "transaction_date",
                          label: "Transaction Date",
                        },
                        // {
                        //   key: "payment_amount",
                        //   label: "Payment Amount",
                        // },
                      ],
                    }}
                  >
                    <Button
                      className="border-gray-300"
                      variant={sortBy ? "filled" : "outlined"}
                      color={sortBy ? "primary" : "default"}
                      icon={<TbArrowsUpDown />}
                    >
                      Sort
                    </Button>
                  </Dropdown>
                  {sortBy ? (
                    <>
                      <Button
                        color="default"
                        className="border-gray-300 px-2"
                        icon={sortOrder === -1 ? <TbSortDescendingNumbers /> : <TbSortAscendingNumbers />}
                        onClick={() => {
                          setSearchParams((prev) => {
                            const newParams = new URLSearchParams(prev);
                            newParams.set("sortOrder", (sortOrder === 1 ? -1 : 1).toString());
                            return newParams;
                          });
                        }}
                      >
                        <Typography.Text className="text-xs w-10">{sortOrder === -1 ? "DESC" : "ASC"}</Typography.Text>
                      </Button>
                      <Button
                        icon={<TbX />}
                        onClick={() => {
                          setSearchParams((prev) => {
                            const newParams = new URLSearchParams(prev);
                            newParams.delete("sortBy");
                            newParams.delete("sortOrder");
                            return newParams;
                          });
                        }}
                      />
                    </>
                  ) : null}
                </Space.Compact>
                {transactionMonths?.data && transactionMonths?.data?.months?.length > 0 ? (
                  <Select
                    value={selectedMonth}
                    onChange={(val) => {
                      setSelectedMonth(val);
                      const startDate = dayjs(val, "YYYY/MM").startOf("month").format("YYYY-MM-DD");
                      const endDate = dayjs(val, "YYYY/MM").endOf("month").format("YYYY-MM-DD");

                      setSearchParams((prev) => {
                        const newSP = new URLSearchParams(prev);
                        newSP.set("start_date", startDate);
                        newSP.set("end_date", endDate);
                        return newSP;
                      });
                      setStartDate(startDate);
                      setEndDate(endDate);
                    }}
                    options={transactionMonths?.data?.months?.map((el) => ({
                      label: dayjs(el, "YYYY/MM").format("MMM YYYY"),
                      value: el,
                    }))}
                  />
                ) : null}
                <DatePicker.RangePicker
                  value={[
                    startDate ? dayjs(startDate, "YYYY-MM-DD") : null,
                    endDate ? dayjs(endDate, "YYYY-MM-DD") : null,
                  ]}
                  onChange={(dates, dateStrings) => {
                    setSearchParams((prev) => {
                      const newParams = new URLSearchParams(prev.toString());
                      if (dateStrings[0]) {
                        newParams.set("start_date", dateStrings[0]);
                      } else {
                        newParams.delete("start_date");
                      }
                      if (dateStrings[1]) {
                        newParams.set("end_date", dateStrings[1]);
                      } else {
                        newParams.delete("end_date");
                      }
                      return newParams;
                    });
                    setStartDate(dateStrings[0]);
                    setEndDate(dateStrings[1]);
                  }}
                  className="!py-2"
                />
              </div>
            </>
          </div>

          <Table
            scroll={{ x: 1500, y: "calc(100vh - 160px)" }}
            columns={columns}
            dataSource={bank.data?.result.data}
            loading={bank.isLoading}
            rowClassName={(record) => (selectedRow.includes(record.id) ? "!bg-purple-100" : "")}
            rowSelection={{ type: "checkbox", ...rowSelection }}
            rowKey="id"
            size="small"
            className="!px-4"
            pagination={{
              hideOnSinglePage: false,
              showQuickJumper: true,
              showPrevNextJumpers: true,
              nextIcon: (
                <Button
                  className="ant-pagination-item-link !flex items-center justify-center"
                  type="text"
                  icon={<TbChevronRight size={20} />}
                />
              ),
              prevIcon: (
                <Button
                  className="ant-pagination-item-link !flex items-center justify-center"
                  type="text"
                  icon={<TbChevronLeft size={20} />}
                />
              ),
              showTitle: true,
              showTotal: (total, range) => {
                return `Showing ${range[0]}-${range[1]} of ${total} transactions`;
              },
              showSizeChanger: true,
              total: bank.data?.result?.totalObjects,
              current: page,
              pageSize: limit,
              onChange: (page, pageSize) => {
                setSearchParams((prev) => {
                  const newParams = new URLSearchParams(prev);
                  newParams.set("page", page.toString());
                  newParams.set("limit", pageSize.toString());
                  return newParams;
                });
              },
            }}
          />
        </>
      ) : (
        <div className="px-4" style={{ width: "100%", height: "90vh" }}>
          <iframe src={iframeUrl} width="100%" height="100%" frameBorder="0" title="Datasense Insight" />
        </div>
      )}
      <Modal
        title="Update Category Details"
        open={isModalOpen}
        okButtonProps={{
          loading:
            updateCategoryMutation.isPending ||
            bulkCategoryUpdateMutation.isPending ||
            updateSingleCategoryMutation.isPending,
        }}
        onOk={() => form.submit()}
        onCancel={() => setIsModalOpen(false)}
      >
        <Form
          onFinish={(values) => {
            const scopeMap: Record<ScopeOption, string> = {
              single: "",
              category: "self",
              application: "all",
            };

            if (isBulkUpdate) {
              bulkCategoryUpdateMutation.mutate(
                { id: selectedRow, category: values.category!, subcategory: values.sub_cat },
                {
                  onSuccess: () => {
                    message.success(`${selectedRow.length} Transaction(s) updated successfully!`);
                    form.resetFields();
                    setIsModalOpen(false);
                    bank.refetch();
                    markedReceivables.refetch();
                    setSelectedRow([]);
                  },
                },
              );
            } else if (!isBulkUpdate && indivudaulUpdate) {
              updateSingleCategoryMutation.mutate(
                { id: transactionId!, category: values.category!, subcategory: values.sub_cat },
                {
                  onSuccess: () => {
                    message.success("Transaction updated successfully!");
                    form.resetFields();
                    setIsModalOpen(false);

                    bank.refetch();
                    markedReceivables.refetch();
                  },
                },
              );
            } else {
              updateCategoryMutation.mutate(
                {
                  category: values.category!,
                  description: transactionDescription || " ",
                  appkey: appKey!,
                  scope: scopeMap[values.scope as ScopeOption] ?? "",
                },
                {
                  onSuccess: () => {
                    message.success(
                      `Update submitted. It will be reflected within ${scopeMap[values.scope as ScopeOption] === "self" ? "5" : "20"} minutes!`,
                    );
                    form.resetFields();
                    setIsModalOpen(false);
                    setIsIndividaulUpdate(true);
                  },
                },
              );
            }
          }}
          form={form}
          layout="vertical"
        >
          <Form.Item
            label="Category"
            name={"category"}
            rules={[{ required: true, message: "Please select a category" }]}
          >
            <AutoComplete
              value={selectedCategory}
              onChange={(val) => setSelectedCategory(val)}
              placeholder="Select or type a category"
              options={availableCategories.map((cat) => ({ value: cat }))}
              filterOption={(inputValue, option) => option!.value.toLowerCase().includes(inputValue.toLowerCase())}
            />
          </Form.Item>
          <Form.Item name={"sub_cat"} label="Subcategory">
            <AutoComplete
              value={form.getFieldValue("sub_cat")}
              onChange={(val) => form.setFieldsValue({ sub_cat: val })}
              placeholder="Select or type a subcategory"
              options={availableSubCategories.map((s) => ({ value: s }))}
              filterOption={(inp, opt) => opt!.value.toLocaleLowerCase().includes(inp.toLocaleLowerCase())}
            />
          </Form.Item>

          {!isBulkUpdate && editScopeAll && (
            <Form.Item name="scope" initialValue="single">
              <Radio.Group
                onChange={(e) => {
                  const val = e.target.value as ScopeOption;
                  setIsIndividaulUpdate(val === "single");
                }}
              >
                <Tooltip title="Only this selected transaction will be updated">
                  <span>
                    <Radio value="single">Only this transaction</Radio>
                  </span>
                </Tooltip>

                <Tooltip title="This will update all transactions that have the same category">
                  <span>
                    <Radio value="category">All transactions with this category</Radio>
                  </span>
                </Tooltip>

                {user.role === RoleTypes.SUPERADMIN && (
                  <Tooltip title="This will update transactions across all applications in the system">
                    <span>
                      <Radio value="application">All applications</Radio>
                    </span>
                  </Tooltip>
                )}
              </Radio.Group>
            </Form.Item>
          )}
        </Form>
      </Modal>
      <Modal
        title="Mark Recievables Protected"
        open={recievablesModal}
        onCancel={() => setRecievablesModal(false)}
        footer={null}
        width={520}
      >
        <div style={{ maxHeight: 450, overflow: "auto" }}>
          {upstream.map((item) => (
            <div key={item} className="flex items-center justify-between py-2 border-b">
              <div className="flex items-center gap-2">
                <TbCircleCheck size={18} />
                <span>{item}</span>
              </div>

              <Switch
                checked={categories[item] === true}
                onChange={() => toggle(item)}
                loading={markRecievable.isPending}
              />
            </div>
          ))}
          {upstream.length === 0 && (
            <Typography className="text-center">No categories have been assigned to statements yet.</Typography>
          )}
        </div>
      </Modal>
    </DashboardLayout>
  );
};

export default BankAccount;
